import React from 'react'

import { niceJoin } from '../../lib/formats'
import DataGrid from '../UI/DataGrid'
import AgencyCard from './AgencyCard'

const ListAgencies = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'name', title: 'Name' },
    { name: 'phone', title: 'Phone' },
    { name: 'address', title: 'Address' },
    { name: 'location', title: 'Location' }
  ]

  const gridRowMappingFn = agency => {
    const id = agency.id
    const { name, phone, address, city, province, country } = agency.attributes

    return {
      id: id,
      name: name,
      phone: phone,
      address: address,
      location: niceJoin([city, province, country], ', ', 'N/A')
    }
  }

  const gridSorting = [{ columnName: 'name', direction: 'asc' }]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="agencies"
      resourceSingularName="agency"
      resourcePluralName="agencies"
      nameAttribute="name"
      clientRootPath="/agencies"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      detailsCard={AgencyCard}
    />
  )
}

export default ListAgencies



// WEBPACK FOOTER //
// ./src/components/Agencies/ListAgencies.jsx